import { css } from 'styled-components';

import type { RuleSet } from 'styled-components';

export const breakpoints = {
  // Mobile
  mobileS: 320,
  mobileM: 375,
  mobileL: 432,
  // Tablet
  tablet: 768,
  // Laptop
  laptopS: 936,
  laptop: 1024,
  laptopL: 1439,
  // desktop
  desktopM: 1440,
  desktop: 2560,
};

const size = {
  all: '0px',
  mobileS: `${breakpoints.mobileS}px`,
  mobileM: `${breakpoints.mobileM}px`,
  mobileL: `${breakpoints.mobileL}px`,
  tablet: `${breakpoints.tablet}px`,
  laptopS: `${breakpoints.laptopS}px`,
  laptop: `${breakpoints.laptop}px`,
  laptopL: `${breakpoints.laptopL}px`,
  desktopM: `${breakpoints.desktopM}px`,
  desktop: `${breakpoints.desktop}px`,
};

const deviceMedia = {
  all: `(min-width: ${size.all})`,
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptopS: `(min-width: ${size.laptopS})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktopM: `(min-width: ${size.desktopM})`,
  desktop: `(min-width: ${size.desktop})`,
};

enum OrientationType {
  Unknown = 'unknown',
  Portrait = 'portrait',
  Landscape = 'landscape',
}

const constructCssMedia = (
  cssCode: RuleSet<object>,
  media: string,
  orientation: OrientationType = OrientationType.Unknown
) => {
  const mediaQuery =
    orientation !== OrientationType.Unknown
      ? `screen and ${media} and (orientation: ${orientation})`
      : `screen and ${media}`;

  return css`
    @media ${mediaQuery} {
      ${cssCode}
    }
  `;
};

export const device = {
  all: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.all),
  mobileS: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.mobileS),
  mobileM: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.mobileM),
  mobileL: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.mobileL),
  tablet: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.tablet),
  laptopS: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.laptopS),
  laptop: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.laptop),
  laptopL: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.laptopL),
  desktopM: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.desktopM),
  desktop: (cssCode: RuleSet<object>) =>
    constructCssMedia(cssCode, deviceMedia.desktop),
};
